/*
 * Pagination view
 */

define([
  "marionette",
  "jquery",
  "modules/shared/sortableList/sortableListPagination/template/sortableListPaginationTemplate.html",
], function (Marionette, $, SortableListPaginationTemplate) {
  var SortableListPaginationView = {};

  SortableListPaginationView.sortableListPaginationView = Marionette.ItemView.extend({
    template: SortableListPaginationTemplate,
    triggers: {
      "click #back": "back",
      "click #next": "next",
    },
    events: {
      "change select": function () {
        var optionSelected = this.$el.find("select option:selected").text();
        this.trigger("change:page:size", optionSelected);
      },
    },
    modelEvents: {
      "change:currentPage": "render",
      "change:endRecord": "render",
      "change:numberOfRecords": "render",
      "change:pageCount": "render",
      "change:recordsPerPage": "render",
      "change:startRecord": "render",
    },
  });

  return SortableListPaginationView;
});
